'use client';

import { ComponentProps } from 'react';
import { useIntl } from 'react-intl';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import AlgoliaSearchBox from '@alltrails/search/components/AlgoliaSearchBox';
import { useIsTripPlannerEntryPointVisible } from '../../hooks/tripPlannerAvailability';
import { tripPlannerSearchResultHref } from '../../utils/tripPlannerEntryParams';
import styles from './styles/styles.module.scss';

export type SearchBoxProps = Pick<
  ComponentProps<typeof AlgoliaSearchBox>,
  | 'clearOnSelect'
  | 'configs'
  | 'getCurrentLatLng'
  | 'navigateOnSelect'
  | 'onAddressSelect'
  | 'onInputBlur'
  | 'onInputFocus'
  | 'onResultSelect'
  | 'onTripPlannerSelect'
  | 'searchRequestLoading'
  | 'tertiaryElement'
  | 'value'
>;

const SearchBox = (searchProps: SearchBoxProps) => {
  const intl = useIntl();
  const isTripPlannerV2Enabled = useExperiments()['web-disco-rm-trip-planner-v2']?.value === 'on';
  const isTripPlannerVisible = useIsTripPlannerEntryPointVisible();

  const placeholder = intl.formatMessage({ defaultMessage: 'Search' });

  return (
    <div className={styles.searchBox}>
      <AlgoliaSearchBox
        {...searchProps}
        dropdownVariant="enveloping"
        tripPlannerHref={isTripPlannerV2Enabled && isTripPlannerVisible ? tripPlannerSearchResultHref : undefined}
        placeholder={placeholder}
        searchOrigin="global nav"
        searchTypes="all"
        showTrendingSuggestions
        variant="subtle"
        useTypeAhead
      />
    </div>
  );
};
export default SearchBox;
